"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggerName = exports["default"] = void 0;
var _logger = require("@studio/logger");
var loggerName = exports.loggerName = 'redux-action-debugger';

/**
 * Target all actions and send datadog logs if any is found not to have a type
 * or with a payload === undefined. This middleware can always be commented
 * out at the point of usage to disable it.
 * @returns {function(*): function(*): *}
 */
function actionDebugger() {
  return function (next) {
    return function (action) {
      // This log is for debugging purposes to check if we have any actions that
      // have undefined types or whose payload is set explicitly to undefined.
      var logPayload;
      if (!action.type && !action.payload) {
        logPayload = {
          title: 'Both action type and payload are undefined'
        };
      } else if (!action.type) {
        logPayload = {
          title: 'Action type is not defined'
        };
      } else if (action.payload === undefined) {
        logPayload = {
          title: 'Action payload === undefined'
        };
      }
      if (logPayload) {
        logPayload.action = action;
        (0, _logger.sendToDatadog)(loggerName, logPayload, logPayload.title, false);
      }
      return next(action);
    };
  };
}
var _default = exports["default"] = actionDebugger;